<section id="main">
    <div ng-if="vm.step == 1" 
         class="container-fluid cards-container">
        <div class="row m-0">
            <div class="tmplt-list-title col-xs-12 mt-3">
                <h2 translate="cards.settings" class="f-24"></h2>
            </div>
        </div>
        <div class="settings-item-wrap">
            <div class="settings-item">
                <div class="flex-1">                
                    <h3 class="settings-item-title" translate="cards.temporaryBlock"></h2>
                    <h5 ng-if="vm.card.isBlocked" 
                        class="settings-item-subtitle" translate="cards.cardBlocked"></h4>  
                    <h5 ng-if="!vm.card.isBlocked"  
                        class="settings-item-subtitle" translate="cards.cardActive"></h4>  
                </div>
                <addiko-switch model="vm.card.isBlocked"></addiko-switch>
            </div>
        </div>

        <div class="settings-item-wrap">
            <div class="settings-item">
                <div class="flex-1">                
                    <h3 class="settings-item-title" translate="cards.onlineShopping"></h2>
                    <h5 ng-if="vm.card.onlineShoppingIsActive" 
                        class="settings-item-subtitle" translate="cards.enabled"></h4>  
                    <h5 ng-if="!vm.card.onlineShoppingIsActive"  
                        class="settings-item-subtitle" translate="cards.disabled"></h4>  
                </div>
                <addiko-switch model="vm.card.onlineShoppingIsActive"></addiko-switch>
            </div>
        </div>
        <div class="row m-0">
            <div class="tmplt-list-title col-xs-12 mt-3">
                <h2 translate="cards.dailyLimits" class="f-20"></h2>
            </div>
        </div>
        <div ng-if="vm.limitTypeChangeInProgress" class="limit-type-backdrop"></div>
        <div ng-repeat="limitType in vm.limitTypes" 
             class="settings-item-wrap"
             ng-class="{'focused': !limitType.disabled, 'changed': limitType.changed}">
            <div class="limit-item">
                <div class="flex-1">                
                    <h3 class="settings-item-title">{{('cards.' + limitType.type) | translate}}</h2>
                </div>
                <addiko-switch ng-if="limitType.disabled" model="vm.card['limit'+ limitType.type]"></addiko-switch>
                <span ng-if="!limitType.disabled" 
                      ng-click="vm.closeLimit(limitType)"
                      class="icon cursor-pointer icon-close"></span>
            </div>
            <div class="limits-wrap">
                <div class="limit"> 
                    <label class="addiko-new-label" translate="cards.dailyLimit"></label>
                    <input type="text" name="atmLocation" class="addiko-new-input" 
                           ng-model="vm.card['limitAmount' + limitType.type]"
                           ng-disabled="limitType.disabled"
                           required autocomplete="off">
                    <span class="currency">{{vm.card.limitCurr}}</span>
                </div>
                <div class="limit">
                    <label class="addiko-new-label ml-3" translate="cards.trnNo"></label>
                    <input type="number" name="atmLocation" class="addiko-new-input" 
                           ng-model="vm.card['limitTrnNo' + limitType.type]"
                           min="0"
                           ng-disabled="limitType.disabled"
                           required autocomplete="off">
                </div>
                <div class="limit">
                    <button ng-if="limitType.disabled" 
                            ng-click="vm.changeLimit(limitType)"
                            class="addiko-btn-new addiko-btn-new--outline d-flex align-items-center">
                        <span class="icon-edit"></span>
                        <span translate="cards.change"></span>
                    </button>
                    <button ng-if="!limitType.disabled" 
                            ng-click="vm.confirmLimit(limitType)"
                            class="addiko-btn-new addiko-btn-new--primary d-flex align-items-center">
                        <span class="icon-check ml-3 mr-3"></span>
                        <span translate="cards.save" ></span>
                    </button>
                </div>
            </div>
            <div ng-if="!limitType.disabled" 
                class="limit-info">
                <span class="info-icon"></span>
                <p translate="cards.dailyLimitInfo"></p>
            </div>
        </div>
       
        <div class="row m-0 pt-3">
            <div class="col-xs-6 col-sm-3">
                <button class="btn btn-primary pull-left" 
                        translate="cards.cancel"
                        ng-click="vm.goToCard()">
                </button>
            </div>
            <div class="col-xs-6 col-sm-3 col-sm-offset-6">
                <button translate="cards.acceptChanges" 
                        ng-click="vm.acceptChanges()"
                        class="btn btn-default pull-right"></button>
            </div>
        </div>
    </div>
    <div ng-if="vm.step == 2" 
         class="container-fluid cards-container">
         <card-sign title="cards.settingsSign" card="vm.card" request="vm.request"></card-sign>
    </div>
</section>